export const getCurrencyFromSearchParams = () => {
  const params = new URLSearchParams(window.location.search);
  return params.get("currency") ?? "USD";
};
